/**
 * Domain-based branding configuration
 */
import { hostname } from './utils';

/**
 * Brand configuration interface
 */
export interface BrandConfig {
  primary: string;
  secondary: string;
  background: string[];
  appBarBg: string;
  logo: string;
  name: string;
  icons: string;
}

/**
 * All branding configurations keyed by domain
 */
const BRAND_CONFIGS: Record<string, BrandConfig> = {
  'mafiamiss.com': {
    primary: '#5c6bc0',
    secondary: '#ef5350',
    background: ['#0f0c29', '#302b63', '#211e45', '#1a162e'],
    appBarBg: 'rgba(15, 12, 41, 0.7)',
    logo: 'MafiaMiss.png',
    name: 'Mafia Miss',
    icons: ''
  },
  
  'default': {
    primary: '#5c6bc0',
    secondary: '#ef5350',
    background: ['#0f0c29', '#302b63', '#211e45', '#1a162e'],
    appBarBg: 'rgba(15, 12, 41, 0.7)',
    logo: '/Mafia IL.svg',
    name: 'Mafia Israel',
    icons: '🎗🇮🇱'
  }
};

/**
 * Get the appropriate brand configuration based on the current hostname
 * @returns The brand configuration for the current domain
 */
export const getBrandConfig = (): BrandConfig => {
  const host = hostname();
  // For testing locally, use a URL parameter to override the branding
  if (typeof window !== 'undefined') {
    const urlParams = new URLSearchParams(window.location.search);
    const brandParam = urlParams.get('brand');
    
    if (brandParam) {
      console.log('Brand override from URL:', brandParam);
      if (brandParam === 'miss') {
        return BRAND_CONFIGS['mafiamiss.com'];
      } else if (brandParam === 'israel') {
        return BRAND_CONFIGS['mafia-il.netlify.app'];
      }
    }
  }
  
  // For localhost or 127.0.0.1, use default with a modified name
  if (host === 'localhost' || host === '127.0.0.1') {
    return {
      ...BRAND_CONFIGS.default,
      name: 'Mafia Israel (Local)',
    };
  }
  
  const config = BRAND_CONFIGS[host] || BRAND_CONFIGS.default;
  console.log('Using brand config for:', host, config.name);
  return config;
};
